export default "__VITE_ASSET__b6d33e1f__"